<section data-testid="c360-product-use" class="c360-section">
  <header class="c360-section__head">
    <h2 class="c360-section__title">Product use</h2>
    <p class="c360-section__subtitle">What the company does with XatBot and the tools around it.</p>
  </header>
  <div class="c360-grid">
    <article data-testid="c360-xatbot-card" class="c360-card" [ngClass]="hasMonthlyQuality ? 'c360-span-6' : 'c360-span-8'">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">XatBot questions and spend</h3>
          <p data-testid="c360-xatbot-summary" class="c360-card__description">{{ summary }}</p>
        </div>
      </div>
      <div class="c360-card__body">
        <div #chart data-testid="c360-xatbot-chart" class="c360-chart c360-chart--md"></div>
      </div>
    </article>
    <article *ngIf="hasMonthlyQuality" data-testid="c360-quality-card" class="c360-card c360-span-6">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">Unresolved rate and negative feedback</h3>
          <p data-testid="c360-quality-summary" class="c360-card__description">By month. A month under 10 questions has no rate.</p>
        </div>
      </div>
      <div class="c360-card__body">
        <app-admin-dashboard-empty *ngIf="!qualityHasQuestions" data-testid="c360-quality-empty" [compact]="true"
                                   icon="fa-regular fa-comment-dots" [title]="'No XatBot questions in the last 12 months'"></app-admin-dashboard-empty>
        <div *ngIf="qualityHasQuestions" #qualityChart data-testid="c360-quality-chart" class="c360-chart c360-chart--md"></div>
        <p *ngIf="qualityHistoryText" data-testid="c360-quality-collecting" class="c360-note">{{ qualityHistoryText }}</p>
      </div>
    </article>
    <article data-testid="c360-use-card" class="c360-card" [ngClass]="hasMonthlyQuality ? 'c360-span-12' : 'c360-span-4'">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">Quality, entities and packages</h3>
          <p class="c360-card__description">XatBot quality over the last 30 days, and what the company holds.</p>
        </div>
      </div>
      <div class="c360-card__body">
        <ng-container *ngIf="productUse as p">
          <div data-testid="c360-quality" class="c360-product-use__quality">
            <ng-container *ngIf="p.Quality && p.Quality.unresolvedRate !== null; else fewQuestions">
              {{ p.Quality.xatBotQuestions | adbCount:'question' }} · {{ p.Quality.unresolvedRate | percent:'1.0-0' }} unresolved ·
              {{ p.Quality.negativeRate | percent:'1.0-1' }} negative (30 days)
            </ng-container>
            <ng-template #fewQuestions>Too few questions to rate</ng-template>
          </div>
          <div class="c360-product-use__entities">Entities: {{ p.Entities }}</div>
          <div class="c360-product-use__packages">
            <span *ngFor="let package of p.Packages" data-testid="c360-package" class="c360-pill" data-tone="blue">{{ package.name }}</span>
          </div>
        </ng-container>
        <div class="c360-card__actions">
          <button mat-stroked-button class="adb-natural-width" type="button" data-testid="c360-eat-link"
                  (click)="router.navigateByUrl('/administration/usage-report/eat-usage-report-by-company/' + companyId)">E.A.T. usage</button>
        </div>
      </div>
    </article>
  </div>
</section>
